import { Phone, Mail, MessageCircle } from "lucide-react";
import { KONTAKT } from "@/components/schulungen/roles";

export default function KontaktKarte({ firmenname }) {
  const waText = encodeURIComponent(`Hallo Herr Weinacht, wir haben eine Frage zur Schulung (${firmenname || "Firmenportal"}).`);
  return (
    <div className="bg-slate-900 text-white rounded-2xl p-6 relative overflow-hidden" data-testid="kontakt-karte">
      <div className="absolute -top-12 -right-12 w-40 h-40 bg-cyan-700/40 rounded-full blur-2xl" />
      <div className="relative">
        <p className="text-xs font-semibold tracking-wider uppercase text-cyan-300">Ihr persönlicher Ansprechpartner</p>
        <div className="mt-4 flex items-center gap-4">
          <div className="h-14 w-14 rounded-full bg-cyan-700 text-white font-bold text-lg flex items-center justify-center font-['Manrope'] shrink-0">KW</div>
          <div>
            <p className="font-['Manrope'] text-lg font-bold leading-tight">{KONTAKT.name}</p>
            <p className="text-sm text-slate-300">{KONTAKT.rolle}</p>
          </div>
        </div>
        <p className="mt-4 text-sm text-slate-300 leading-relaxed">Fragen zu Bestellung, Rechnung oder Präsenzterminen? Wir sind Mo–Fr, 10:00–14:00 Uhr persönlich erreichbar.</p>
        <div className="mt-5 grid gap-2">
          <a href={`https://wa.me/${KONTAKT.whatsapp}?text=${waText}`} target="_blank" rel="noopener noreferrer" data-testid="kontakt-whatsapp-btn"
            className="flex items-center justify-center gap-2 h-12 rounded-xl bg-green-600 hover:bg-green-500 text-white font-semibold transition-colors">
            <MessageCircle className="h-5 w-5" /> Per WhatsApp schreiben
          </a>
          <a href={`tel:${KONTAKT.telefon}`} data-testid="kontakt-telefon-btn"
            className="flex items-center justify-center gap-2 h-12 rounded-xl bg-white/10 hover:bg-white/20 text-white font-semibold transition-colors">
            <Phone className="h-5 w-5" /> {KONTAKT.telefonAnzeige}
          </a>
          <a href={`mailto:${KONTAKT.email}`} data-testid="kontakt-email-btn"
            className="flex items-center justify-center gap-2 h-11 rounded-xl text-sm text-slate-300 hover:text-white transition-colors">
            <Mail className="h-4 w-4" /> {KONTAKT.email}
          </a>
        </div>
      </div>
    </div>
  );
}
